import styled from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';

export const Container = styled('section')<any>`
  padding: ${({ theme, isMobileView }): string =>
    `${theme.spacing.large} ${
      isMobileView ? theme.spacing.large : theme.spacing.xxlarge
    }`};
  margin: 1em auto;

  @media screen and (min-width: 50em) {
    width: ${({ theme }): number => theme.layout.smallScreen * 100}%;
  }

  @media screen and (min-width: 80em) {
    width: ${({ theme }): number => theme.layout.largeScreen * 100}%;
  }

  @media screen and (max-width: 50em) {
    padding: 10px;
    margin: 0;
  }
`;

export const FAQActivityTrackerBlockWrapper = styled('div')<any>`
  display: flex;
  flex-direction: row;
  ${({ isMobileView }): string =>
    isMobileView
      ? `
    flex-direction: column;
    gap: 24px;
  `
      : ''}
`;

export const TextBlockWrapper = styled('div')`
  width: 100%;
  background: #ffffff;
  padding: 25px 60px;

  @media screen and (max-width: 50em) {
    padding: 20px 40px;
  }
`;

export const Message = styled('p')`
  font-size: 16px;
  color: #000a29;
  max-width: 328px;
`;

export const BlockWrapper = styled('div')`
  padding: 40px 0 45px 0;
  max-width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid #e8ebed;
  }

  @media screen and (max-width: 50em) {
    padding: 20px 0;
  }
`;

export const BlockTitle = styled('h1')`
  font-size: 24px;
  font-weight: 700;
  color: #000a29;
`;

export const TableHead = styled('thead')`
  display: table;
  width: 100%;
  text-transform: uppercase;
  padding-bottom: 8px;
  overflow: hidden;
`;

export const TableBody = styled('tbody')`
  display: flex;
  flex-direction: column;
`;

export const TableWrapper = styled('div')`
  height: calc(100% - 110px);
  overflow: scroll;
  width: 100%;
  padding-right: 10px;
  position: absolute;
  top: 110px;

  @media screen and (max-width: 50em) {
    height: calc(100% - 70px);
    top: 70px;
  }
`;

export const TableBlockWrapper = styled('div')`
  width: 100%;
  background: #f8f8f8;
  padding: 65px 55px 45px 65px;

  @media screen and (max-width: 50em) {
    padding: 24px 16px;
  }
`;

export const Cell = styled('td')`
  text-align: center;
  padding: ${({ theme }): string =>
    `${theme.spacing.small} ${theme.spacing.xxsmall}`};
  ${({ width }): string => (width ? `width: ${width};` : '')}
`;

export const EntityMeta = styled('p')`
  font-size: ${modularScale(-1)};
  font-weight: normal;
  line-height: 1.2;
  color: ${({ theme }): string => theme.CasperGrey};
  margin: -2px 0 0 0;
`;

export const DSPEntityMeta = styled(EntityMeta)`
  font-size: ${modularScale(-2)};
  text-align: center;
`;

export const RowWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
  min-height: 71px;
`;

export const TH = styled('th')`
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  letter-spacing: 1px;
  color: #8ea6be;
  text-align: left;
  &:last-child {
    text-align: right;
    padding-right: 18px;
  }
`;

export const SearchFieldWrapper = styled('div')`
  label {
    border: 1px solid #e8e8e8;
    background: #ffffff;
    max-height: 54px;
    margin-right: 10px;
    margin-bottom: 30px;
  }
`;

export const BoxPositionRelative = styled('div')<any>`
  position: relative;
  height: ${({ height }): string => (height ? height : '100%')};
`;
